<template>
  <!-- Search Result -->
  <section class="mtl">
    <Breadcrumbs
      :post-info="postInfo"
      :page-info="pageInfo"
    />
    <div
      class="fixed-title desktop"
      :class="{ 'full-height' : scrollPosition > 400 }"
    >
      <div class="grid-container grid-x">
        <div
          class="medium-5 drawer"
        >
          <TableOfContentsButton
            :longform-document="longformDocument"
            dropdown
          />
        </div>
        <div class="medium-19">
          <div
            class="owner"
            v-html="postInfo.post_title"
          />
          <div
            class="mvn"
            v-html="owners[0].name"
          />
        </div>
      </div>
    </div>
    <div class="row mtxl mobile-top-margin">
      <div class="large-24 columns">
        <div class="longform-content-page">
          <div class="grid-x">
            <div class="medium-5 desktop">
              <TableOfContentsButton :longform-document="longformDocument" />
            </div>
            <div class="medium-19 small-24">
              <SearchTabs
                :longform-document="longformDocument"
                :search-this-page-disabled="true"
                :post-info="postInfo"
                @searchAllPages="searchAll"
                @clearAllPages="clearAllPages"
              />
            </div>
          </div>
          <div
            v-if="searchResult"
            class="longform-content-container grid-x mtl search-results"
          >
            <div class="medium-5 prl desktop">
              <h4 v-if="Object.keys(searchResult).length">
                Jump to results for:
              </h4>
              <div
                v-for="(data, index) in searchResult"
                :key="index+'-sidebar'"
                class="jump-item mbm"
              >
                <router-link 
                  :to="{ name: 'SearchResult', params: { section: data[0].primaryIndex }, query: { term: $route.query.term }}"
                  class="pls"
                  v-html="index"
                />
              </div>
            </div>

            <div class="longform-content medium-19">
              <div
                v-for="(data, index) in searchResult"
                :key="index+'-desktop'"
                class="desktop"
              >
                <h2
                  :id="data[0].primaryIndex"
                  class="mtn black bg-ghost-gray"
                  v-html="index"
                />
                <div
                  v-for="(item, itemIndex) in data"
                  :key="itemIndex+'-desktop-1'"
                >
                  <h3 v-if="item.title || item.index">
                    <span
                      v-if="item.index"
                      class="mrm"
                      v-html="item.index"
                    />
                    <span
                      v-if="item.title"
                      v-html="item.title"
                    />
                  </h3>
                  <div
                    v-if="item.description"
                    v-html="philaLink(reducedResult(item.description))"
                  />
                  <router-link 
                    :to="{ name: 'LongformDocument', params: { section: item.primaryIndex }, query: { subsection: item.index, term: decodeURIComponent($route.query.term) }}"
                    class="float-right link-to-section mvm"
                  >
                    link to section <i class="fas fa-angle-right" />
                  </router-link>
                  <hr>
                </div>
              </div>
              <b-collapse 
                v-for="(data, index) in searchResult"
                :key="index+'-mobile'"
                class="card pbm mobile"
                animation="slide"
                :open="false"
              >
                <div
                  slot="trigger"
                  slot-scope="props"
                  class="card-header grid-x dark-ben-franklin"
                  role="button"
                >
                  <span
                    class="small-1 medium-2 result-title"
                    v-html="splitIndexNumber(index).index"
                  />
                  <span
                    class="pls small-19 medium-18 result-title"
                    v-html="splitIndexNumber(index).copy"
                  />
                  <a class="card-header-icon small-4 medium-4 pan">
                    <b-icon
                      :icon="props.open ? 'minus' : 'plus'"
                    />
                  </a>
                  <div class="result-count grid-x">
                    <span class="small-1 medium-2" />
                    <span class="pls small-19 medium-18">{{ data.length }} results</span>
                  </div>
                </div>
                <div class="card-content mtl pvn">
                  <div
                    v-for="(item, itemIndex) in data"
                    :key="itemIndex+'-mobile-1'"
                  >
                    <h4
                      v-if="item.title || item.index"
                      class="subsection-title"
                    >
                      <span
                        v-if="item.index"
                        class="mrm"
                        v-html="item.index"
                      />
                      <span
                        v-if="item.title"
                        v-html="item.title"
                      />
                    </h4>
                    <span
                      v-if="item.description"
                      v-html="philaLink(reducedResult(item.description))"
                    />
                    <router-link 
                      :to="{ name: 'LongformDocument', params: { section: item.primaryIndex }, query: { subsection: item.index }}"
                      class="plm link-to-section mvm"
                      :aria-label="'Link to'+ item.primaryIndex"
                    >
                      <i class="fas fa-angle-right" />
                    </router-link>
                    <hr>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TableOfContentsMobileDrawer
      :longform-document="longformDocument"
      class="mobile mtl"
    />
  </section>
<!-- /Search Result -->
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs.vue';
import SearchTabs from '@/components/SearchTabs.vue';
import TableOfContentsMobileDrawer from '@/components/TableOfContentsMobileDrawer.vue';
import TableOfContentsButton from '@/components/TableOfContentsButton.vue';


export default {
  name: 'SearchResult',
  components: {
    Breadcrumbs,
    SearchTabs,
    TableOfContentsMobileDrawer,
    TableOfContentsButton,
  },
  props: {
    longformDocument: {
      type: Object,
      required: true,
    },
    postInfo: {
      type: Object,
      required: true,
    },
    owners: {
      type: Array,
      required: true,
    },
  },
  data: function() {
    return {
      searchResult: {},
      pageInfo: 'Search results',
      scrollPosition: null,
    };
  },
  watch:{
    $route (){
      this.scrollToDiv(); 
    },
  },
  mounted () {
    let vm = this;
    vm.init();
    window.addEventListener('scroll', this.updateScroll);
    this.$gtag.event('view_item', {
      'event_category': 'longform-content',
      'event_label': this.$route.query.term,
    });
  },
  methods: {
    searchAll(searchResult) {
      this.searchResult = searchResult;
    },
    async init () {
      let vm = this;
      await vm.scrollToDiv(); 
    },
    async scrollToDiv() {
      let vm = this;
      let div = vm.$route.params.section;
      if ( div ) {
        let focusDiv = document.getElementById(div);
        if (focusDiv && focusDiv.display != 'none') {
          let focusDivOffset = focusDiv.offsetTop;
          window.scrollTo({
            top: focusDivOffset,
            behavior: 'smooth',
          });
        }
      }
    },
    reducedResult( resultItem ) {
      let highlightRegex = new RegExp('<span class="highlightText" tabindex="0">(.*?)</span>', "gi");
      if (highlightRegex.test(resultItem)) {
        let matchItem = resultItem.match(highlightRegex)[0]; 
        let returnArray = [];
        let splitItem;
        if ( resultItem.includes('<table') && 
        (resultItem.indexOf("<table") < resultItem.indexOf(matchItem)) && 
        (resultItem.indexOf("table>") > resultItem.indexOf(matchItem)) ) {
          // if resultItem is inside a table, return the table
          returnArray.push(resultItem.substring(resultItem.indexOf("<table"), resultItem.indexOf("table>")+6)); 
        } else {
          splitItem = resultItem.split(matchItem);
          splitItem.forEach(function (item, key, arr) {
            if (key === 0) {
              if (item.split(" ").length > 8) {
                let splitItemFirst = item.split(" ");
                let splitItemFirstLimited = splitItemFirst.slice(Math.max(splitItemFirst.length - 8, 0));
                let splitItemFirstLimitedJoined = '...'+splitItemFirstLimited.join(' ');
                returnArray.push(splitItemFirstLimitedJoined);
              } else if (item.split(" ").length ) {
                returnArray.push(item);
              }
              returnArray.push(matchItem);
            }  else if (key === arr.length - 1){
              if (item.split(" ").length > 8) {
                let splitItemLast = item.split(" ");
                let splitItemLastLimited = splitItemLast.slice(0, 8);
                let splitItemLastLimitedJoined = splitItemLastLimited.join(' ')+'...';
                returnArray.push(splitItemLastLimitedJoined);
              } else if (item.split(" ").length ) {
                returnArray.push(item);
              }
            } else {
              returnArray.push(item);
              returnArray.push(matchItem);
            }
          });
        }
        return returnArray.join(' ');
      }
      return resultItem;
    },
    clearAllPages () {
      let vm = this;
      if(vm.longformDocument) {

        Object.entries(vm.longformDocument).forEach(( [ , section ] ) => {
          section = vm.clearHighlight( section );
          Object.entries(section.children).forEach(( [ , section1 ] ) => {
            section1 = vm.clearHighlight( section1 );
            Object.entries(section1.children).forEach(( [ , section2 ] ) => {
              section2 = vm.clearHighlight( section2 );
              Object.entries(section2.children).forEach(( [ , section3 ] ) => {
                section3 = vm.clearHighlight( section3 );
                Object.entries(section3.children).forEach(( [ , section4 ] ) => {
                  section4 = vm.clearHighlight( section4 );
                  Object.entries(section4.children).forEach(( [ , section5 ] ) => {
                    section5 = vm.clearHighlight( section5 );
                    Object.entries(section5.children).forEach(( [ , section6 ] ) => {
                      section6 = vm.clearHighlight( section6 );
                      Object.entries(section6.children).forEach(( [ , section7 ] ) => { // eslint-disable-line no-unused-vars
                        section7 = vm.clearHighlight( section7 );
                      });
                    });
                  });
                });
              });
            });
          });
        });
      }
    },
    clearHighlight(section) {
      let highlightRegex = new RegExp('<span class="highlightText" tabindex="0">', "gi");
      let spanRegex = new RegExp('</span>', "gi");
      if (highlightRegex.test(section.section_copy)) {
        section.section_copy = section.section_copy.replace(highlightRegex,'').replace(spanRegex, '');
      }
      if (highlightRegex.test(section.section_title)) {
        section.section_title = section.section_title.replace(highlightRegex,'').replace(spanRegex, '');
      }
      return section;
    },
    splitIndexNumber(section) {
      let splitSection = section.split(" ");
      let splitIndex = splitSection.shift();
      let splitCopy = splitSection.join(' ');
      let splitSectionOutput = { 
        'index': splitIndex, 
        'copy': splitCopy,
      };
      return splitSectionOutput;
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
};
</script>